import {
  GET_NEGATIVE_OTS_ORDER_WISE_REQUEST,
  GET_NEGATIVE_OTS_ORDER_WISE_SUCCESS,
  GET_NEGATIVE_OTS_ORDER_WISE_ERROR,
} from "../actions/types";

export const NegativeOtsOrderWise = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_NEGATIVE_OTS_ORDER_WISE_REQUEST:
      return {
        loading: true,
      };
    case GET_NEGATIVE_OTS_ORDER_WISE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_NEGATIVE_OTS_ORDER_WISE_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
